import React from 'react';
import './PrimarySectionAdditionActionItem.scss';

const PrimarySectionAdditionActionItem: React.FC = props => {
  return <div className="PrimarySectionAdditionActionItem">{props.children}</div>;
};

export default PrimarySectionAdditionActionItem;
